import { addMutator } from '@poa/state';

import { fetch, fetchSuccess, fetchFailed, setDates } from './plugin.actions';

// fetch
addMutator(fetch, (payload, { store }) => {
  store.plugin.meta.isLoading = true;
  store.plugin.meta.hasError = false;
});

addMutator(fetchSuccess, ({ data }, { store }) => {
  store.plugin.meta.isLoading = false;
  store.plugin.meta.hasError = false;
  store.plugin.data = data;

  store.plugin.meta.loaded = true;
});

addMutator(fetchFailed, (payload, { store }) => {
  store.plugin.meta.isLoading = false;
  store.plugin.meta.hasError = true;
});

addMutator(setDates, (payload, { store }) => {
  if (payload.startDate) {
    store.plugin.filters.startDate = payload.startDate;
  }

  if (payload.endDate) {
    store.plugin.filters.endDate = payload.endDate;
  }
});
